import { Checkbox } from "@mui/material";
import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import NivelAprovacaoService from "service/administracao/cadastro/nivelaprovacao/NivelAprovacaoService";
import { TextMatchModeOptions, filterApplyTemplate } from "utils/filterUtils";

const nivelAprovacaoService = new NivelAprovacaoService();

export default function NivelAprovacaoListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Nível de Aprovação');

    const defaultFilters: DataTableFilterMeta = {
        codigo: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        nome: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        tipoRotina: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
    }

    return (

        <BaseListagem ordenacao="nome,ASC" service={nivelAprovacaoService} urlService="/nivelaprovacao" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="nivelaprovacao">
            <Column
                field="codigo" header="Código" filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterPlaceholder="Escreva o filtro"
            />
            <Column
                field="nome" header="Nome" filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterPlaceholder="Escreva o filtro"
            />
            <Column
                field="tipoRotina" header="Rotina" filter showFilterOperator={false} showAddButton={false}
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} filterPlaceholder="Escreva o filtro"
                body={(rowData) => nivelAprovacaoService.getTipoRotina(rowData.tipoRotina)}
            />
            <Column field="ativo" header="Ativo" style={{ width: '5em', textAlign: "center" }} body={(rowData) => <Checkbox checked={rowData.ativo} />} />
        </BaseListagem>
    )
}
